import { render, staticRenderFns } from "./formProducts.vue?vue&type=template&id=3e189bee"
import script from "./formProducts.vue?vue&type=script&lang=js"
export * from "./formProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports